import React,{useState,useEffect} from 'react'
import { Fieldset } from 'primereact/fieldset';
import { Avatar } from 'primereact/avatar';
import { Image } from 'primereact/image';
import { Galleria } from 'primereact/galleria';
import { Skeleton } from 'primereact/skeleton';
import { Divider } from 'primereact/divider';


const ProductDetails = ({itemId,category, description, name, inventoryStatus, productImage, rating, sellingPrice}) => {

    const [productImages, setProductImages] = useState([productImage,productImage]);
    const [categories, setCategories] = useState([]);


    const ImageResponsiveOptions = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '575px',
            numVisible: 1
        }
    ];

    const imageTemplate = (item) => {
        return <img src={`data:image/jpeg;base64,${productImage}`} alt="No preview avaialable" style={{height:'300px', display: 'block',backgroundRepeat:'no-repeat',backgroundSize:'contain' }} />;
    }

    const thumbnailTemplate = (item) => {
        return <img src={`data:image/jpeg;base64,${productImage}`} alt="No preview avaialable" style={{ display: 'block',height: '80px' }} />;
    }



    useEffect( ()=>{
        setCategories(category);
    },[]);


    const legendTemplate = (
        <div className="flex align-items-center gap-2 px-2">
            <Avatar image={`data:image/jpeg;base64,${productImage}`} size="large" shape="circle" />
            <span className="font-bold">{name}</span>
        </div>
    );

  return (
    <div>
    <Galleria value={productImages} responsiveOptions={ImageResponsiveOptions} numVisible={5} circular style={{ maxWidth: '100%'}}
                showItemNavigators item={imageTemplate} thumbnail={thumbnailTemplate} />
                   <br/>                  <br/>

                   <div className="card">
            <Fieldset legend={legendTemplate}>
                <p className="m-0">
                    {description}
                </p>
            </Fieldset>
        </div>
                  <br/>
                  <div className="flex flex-wrap">
                <div className="w-full md:w-6 p-3">
                    <h5>Basic Details</h5>
                    <span className="flex align-items-center gap-2">
                        <i className="pi pi-tag"></i>
                        <span className="font-semibold">{categories.name}</span>
                    </span>
                    <span className="flex align-items-center gap-2">
                        <i className="pi pi-hashtag"></i>
                        <span className="font-semibold">Dummy size</span>
                    </span>
                    <span className="flex align-items-center gap-2">
                        <i className="pi pi-palette"></i>
                        <span className="font-semibold">Dummy color</span>
                    </span>
                    <span className="flex align-items-center gap-2">
                        <i className="pi pi-expand"></i>
                        <span className="font-semibold">Dummy Material</span>
                    </span>                    
                </div>
                <div className="w-full md:w-6 p-3">
                    <h5>Pricing details</h5>
                            <span className="flex align-items-center gap-2">
                                <i className="pi pi-pound"></i>
                                <span className="font-semibold">Dummy productSellingPrice</span>
                            </span>
                            <span className="flex align-items-center gap-2">
                                <i className="pi pi-pound"></i>
                                <span className="font-semibold">Dummy purchasePrice</span>
                            </span>
                            <span className="flex align-items-center gap-2">
                                <i className="pi pi-money-bill"></i>
                                <span className="font-semibold">Dummy currency</span>
                            </span>
                            <span className="flex align-items-center gap-2">
                                <i className="pi pi-tag"></i>
                                <span className="font-semibold">Dummy isTaxable</span>
                            </span>
                            <span className="flex align-items-center gap-2">
                                <i className="pi pi-tag"></i>
                                <span className="font-semibold">Dummy taxrate</span>
                            </span>
                </div>
                <div className="w-full md:w-6 p-3">
                    <h5>Quantifiers</h5>
                    <span className="flex align-items-center gap-2">
                        <i className="pi pi-info-circle"></i>
                        <span className="font-semibold">Dummy quantity</span>
                    </span>
                </div>
                
                <div className="w-full md:w-6 p-3">
                    <h5>other details</h5>
                            <span className="flex align-items-center gap-2">
                                <i className="pi pi-info-circle"></i>
                                <span className="font-semibold">Dummy other description</span>
                            </span>
                            <span className="flex align-items-center gap-2">
                                <i className="pi pi-info-circle"></i>
                                <span className="font-semibold">Dummy other details</span>
                            </span>                        
                </div>
            </div>

            <Divider />
                <h5>Seller details</h5>
                <p>
                    At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui
                    officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus.
                </p>
            <Divider />
                <h5>Warranty details</h5>
                <p>
                    At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui
                    officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus.
                </p>
                       
                
    
        </div>
  )
}

export default ProductDetails
